import { type FC, useEffect } from "react";

import { useDispatch } from "@jti/store/reduxHooks";
import { setCountry } from "@jti/store/slices/LEGACY__checkoutSlice";
import { useCountry } from "@jti/ui";

export const CountrySetter: FC = () => {
  const dispatch = useDispatch();
  const country = useCountry();

  useEffect(() => {
    dispatch(setCountry(country));
  }, [country, dispatch]);
  return null;
};
